<!--  -->
<template>
  <div class="feeeback-detail">
    <div>
      <h1>Feedback</h1>
      <ul class="feeeback-detail-con">
        <li>
          <p>1. Main Themes</p>
          <div v-html="feedbackDetail.mainThemes">
            {{feedbackDetail.mainThemes}}
          </div>
        </li>
        <li>
          <p>2. Intro with story, expanding on</p>
          <div v-html="feedbackDetail.storyIntro">
            {{feedbackDetail.storyIntro}}
          </div>
        </li>
        <li>
          <p>3. Body<br />
            a. Personal Quality</p>
          <div v-html="feedbackDetail.personalQuality">
            {{feedbackDetail.personalQuality}}
          </div>
        </li>
        <li>
          <p>b. Career Potential</p>
          <div v-html="feedbackDetail.careerPotential">
            {{feedbackDetail.careerPotential}}
          </div>
        </li>
        <li>
          <p>c. Program Fit</p>
          <div v-html="feedbackDetail.programFit">
            {{feedbackDetail.programFit}}
          </div>
        </li>
        <li>
          <p>Homework</p>
          <div v-html="feedbackDetail.homework">
            {{feedbackDetail.homework}}
          </div>
        </li>
        <li>
          <p>Suggested time for the next meeting</p>
          <div v-html="feedbackDetail.nextMeetingSuggested">
            {{feedbackDetail.nextMeetingSuggested}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-project-feedback2',
  props: ['feedbackDetail'],
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
